// import {Swiper} from 'swiper/swiper.esm';

export default class SliderController {
    constructor() {
        this.swiper = null;
        this.sliders = [];

        this.init();
    }

    init() {
        if (document.querySelectorAll('.swiper-container').length) {
			import( /* webpackChunkName: "modules/slider" */ 'swiper/swiper.esm').then(e => {
                this.swiper = e.Swiper;

                document.querySelectorAll('.swiper-container').forEach(container => {
                    let settings = {
                        autoHeight: true,
                        spaceBetween: 30,
                        grabCursor: true,
                        on: {},
                    };
                    settings = Object.assign(settings, this.getSpecificOptions(container));

                    if (container.parentElement.querySelector('.indicator')) {
                        settings.on.sliderMove = () => {
                            container.parentElement.querySelector('.indicator').classList.add('hidden');
                        };
                    }
                    
                    const slider = new this.swiper(container, settings);

                    this.sliders.push(slider);
                });
			});
		}
    }

    getSpecificOptions(container) {
        let settings = {
            breakpoints: {},
        };

        settings.breakpoints[app.breakpoints.xs.size] = {
            spaceBetween: app.breakpoints.xs.gutter,
        };

        settings.breakpoints[app.breakpoints.sm.size] = {
            spaceBetween: app.breakpoints.sm.gutter,
        };

        settings.breakpoints[app.breakpoints.md.size] = {
            spaceBetween: app.breakpoints.md.gutter,
        };

        settings.breakpoints[app.breakpoints.lg.size] = {
            spaceBetween: app.breakpoints.lg.gutter,
        };

        if (container.classList.contains('reviews')) {
            settings.autoHeight = false;
            settings.breakpoints = {};
            settings.breakpoints[app.breakpoints.xs.size] = {
                slidesPerView: 1.05,
            };

            settings.breakpoints[app.breakpoints.sm.size] = {
                slidesPerView: 1.1,
            };

            settings.breakpoints[app.breakpoints.md.size] = {
                slidesPerView: 1.5,
            };

            settings.breakpoints[app.breakpoints.lg.size] = {
                slidesPerView: 1.5,
            };

            settings.breakpoints[app.breakpoints.xl.size] = {
                slidesPerView: 2.5,
            };
        }

        if (container.classList.contains('panels')) {
            settings.breakpoints = {};
            settings.breakpoints[app.breakpoints.xs.size] = {
                slidesPerView: 1.2,
            };

            settings.breakpoints[app.breakpoints.sm.size] = {
                slidesPerView: 1.5,
            };

            settings.breakpoints[app.breakpoints.md.size] = {
                slidesPerView: 3,
            };

            settings.breakpoints[app.breakpoints.lg.size] = {
                slidesPerView: 4,
            };
        }

        if (container.classList.contains('gallery')) {
            settings.breakpoints = {};
            settings.breakpoints[app.breakpoints.xs.size] = {
                slidesPerView: 1.5,
            };

            settings.breakpoints[app.breakpoints.sm.size] = {
                slidesPerView: 1.5,
            };

            settings.breakpoints[app.breakpoints.md.size] = {
                slidesPerView: 3,
            };

            settings.breakpoints[app.breakpoints.lg.size] = {
                slidesPerView: 5,
            };
        }

        return settings;
    }

    getResponsiveSliderOptions(ul) {
        let responsiveOptions = {};
        responsiveOptions[app.breakpoints.xs.size] = {
            gutter: app.breakpoints.xs.gutter,
            items: 2,
        };

        responsiveOptions[app.breakpoints.sm.size] = {
            gutter: app.breakpoints.sm.gutter,
            items: 3,
        };

        responsiveOptions[app.breakpoints.md.size] = {
            gutter: app.breakpoints.md.gutter,
            items: 3,
        };

        responsiveOptions[app.breakpoints.lg.size] = {
            gutter: app.breakpoints.lg.gutter,
            items: 4,
        };


        if (ul.classList.contains('reviewSlider')) {
            responsiveOptions[app.breakpoints.xs.size].items = 1;
            responsiveOptions[app.breakpoints.sm.size].items = 1;
            responsiveOptions[app.breakpoints.md.size].items = 1;
            responsiveOptions[app.breakpoints.lg.size].items = 1;
            responsiveOptions[app.breakpoints.xl.size].items = 1;
        }
        

        return responsiveOptions
    }
}